"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePictureUrlFromPerson;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _usePassiveRedux = _interopRequireDefault(require("@sift/resift/usePassiveRedux"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function usePictureUrlFromPerson(person) {
  var preferOfficialPhotos = (0, _usePassiveRedux["default"])(function (state) {
    return (0, _get2["default"])(state, ['settings', 'directory', 'preferOfficialPhotos'], false);
  });

  if (!person) {
    return '';
  }

  var pictureUrl = person.pictureUrl,
      officialPictureUrl = person.officialPictureUrl;

  if (preferOfficialPhotos) {
    return officialPictureUrl || pictureUrl;
  }

  return pictureUrl || officialPictureUrl;
}